"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _GoodDetailsContainer = _interopRequireDefault(require("./GoodDetailsContainer"));

var GoodDetailsReviewContainer = function GoodDetailsReviewContainer(props) {
  return _react.default.createElement(_GoodDetailsContainer.default, (0, _extends2.default)({}, props, {
    reviewMode: true
  }));
};

var _default = GoodDetailsReviewContainer;
exports.default = _default;
module.exports = exports.default;